import { useContext } from 'react';
import { ResponsiveContext } from '../context';

const useResponsiveTools = () => useContext(ResponsiveContext);

export default useResponsiveTools;
